export default __webpack_public_path__ + "static/media/bg-global-left.49fc2730.svg";